module.exports = __webpack_public_path__ + "media/images/icons/action-redo-84f0e0a0a486b3e2b55ec68323510c6d.svg";